import type { RootState } from "@store/store";

// Selectors for AI slides state
export const getAiSlidePrompt = (state: RootState) => state.aiSlides.prompt;
export const getAiSlideStatus = (state: RootState) => state.aiSlides.status;
export const getAiSlideDesign = (state: RootState) => state.aiSlides.design;
export const getAiSlideDesignId = (state: RootState) => state.aiSlides.designId;
export const getAiSlideContentSlide = (state: RootState) =>
  state.aiSlides.contentSlide;
export const getAiSlideContentSlideId = (state: RootState) =>
  state.aiSlides.contentSlide?.id;
export const getAiSlideRegenerateStory = (state: RootState) =>
  state.aiSlides.regenerateStory;
export const getAiSlideBuildingSlideId = (state: RootState) =>
  state.aiSlides.buildingSlideId;
